import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    filterModel: null, 
    sortModel: null, 
    quickFilter: "", 
    dateFromISO: null, 
    dateToISO: null, 
};


const creditNoteUiSlice = createSlice({
    name: "creditNoteUi",
    initialState,
    reducers: {
        setFilterModel: (state, action) => {
            state.filterModel = action.payload || null;
        },
        setSortModel: (state, action) => {
            state.sortModel = action.payload || null;
        },
        setQuickFilter: (state, action) => {
            state.quickFilter = action.payload ?? "";
        },
        setDates: (state, action) => {
            const { fromISO, toISO } = action.payload || {};
            if (fromISO !== undefined) state.dateFromISO = fromISO;
            if (toISO !== undefined) state.dateToISO = toISO;
        },
        resetUi: () => initialState,
    },
});


export const { setFilterModel, setSortModel, setQuickFilter, setDates, resetUi } = creditNoteUiSlice.actions;
export default creditNoteUiSlice.reducer;